import css from './general-contacts.module.scss';
import { CONTACTS } from 'src/constants/routes';
import { Link } from 'react-router-dom';
import { ContactView } from 'src/pages/contacts/contactCard';
import { ContactCard } from 'src/types';
import { useGetContacts } from '../data/queries';
import { Tabs } from '../selected-materials/selected-materials';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

export default function GeneralContacts({ type }: Readonly<{ type: Tabs }>) {
  const { data: contacts = [] } = useGetContacts({ type });

  if (contacts?.length === 0) return null;

  return (
    <div className={css.generalContacts}>
      <div className={css.header}>
        <Link to={CONTACTS.path}>
          <p>Всі контакти</p> <EventLinkIcon />
        </Link>
        <h3>Важливі контакти</h3>
      </div>
      <div className={css.content}>
        {contacts?.map((card: ContactCard) => <ContactView card={card} key={card.id} />)}
      </div>
    </div>
  );
}
